"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCoordinatePairValid = void 0;
exports.isValidGeoJsonGeofenceCoordinates = isValidGeoJsonGeofenceCoordinates;
const isCoordinatePairValid = (coordinates) => {
    // Check if coordinates is defined and is an array
    if (!coordinates || !Array.isArray(coordinates)) {
        return false;
    }
    // Check if coordinates has exactly 2 elements
    if (coordinates.length !== 2) {
        return false;
    }
    // Check if both elements are numbers and not NaN
    return (typeof coordinates[0] === "number" && typeof coordinates[1] === "number" && !isNaN(coordinates[0]) && !isNaN(coordinates[1]));
};
exports.isCoordinatePairValid = isCoordinatePairValid;
function isValidGeoJsonGeofenceCoordinates(value) {
    if (!Array.isArray(value)) {
        return false;
    }
    if (value.length !== 1) {
        return false;
    }
    const coordinatesCollection = value[0];
    // Polygon is created from at least 4 coordinate pairs
    if (!Array.isArray(coordinatesCollection) || coordinatesCollection.length <= 3) {
        return false;
    }
    const openingCoordinates = coordinatesCollection[0];
    const closingCoordinates = coordinatesCollection[coordinatesCollection.length - 1];
    // Polygon must be a closed loop
    if (openingCoordinates[0] !== closingCoordinates[0] || openingCoordinates[1] !== closingCoordinates[1]) {
        return false;
    }
    const allCoordinatesAreValid = coordinatesCollection.every(exports.isCoordinatePairValid);
    return allCoordinatesAreValid;
}
//# sourceMappingURL=isValidGeoJsonGeofenceCoordinates.js.map